const NAME = "SCHOOLING";

export default NAME;
